// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import qs from 'qs'
import 'amfe-flexible/index.js'
import vueEsign from 'vue-esign'
import Vant from 'vant';
import 'vant/lib/index.css';
import VueWechatTitle from 'vue-wechat-title'; 
// let jweixin = require('jweixin-module');
// Vue.prototype.wx = jweixin;
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs;
Vue.use(vueEsign)
Vue.use(Vant);
Vue.use(VueWechatTitle)
window.addEventListener('popstate', function() {
  history.pushState(null, null, document.URL)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js